"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(s) {
  return s.charAt(0).toLowerCase() + s.slice(1);
};